import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { TestConnectionResponse } from '../httpClients/RepositoryClient/api.schema';
import { QUERY_KEYS } from './consts';

type OmittedQueryOptions = Omit<
  UseQueryOptions<TestConnectionResponse, Error, TestConnectionResponse>,
  'queryKey' | 'queryFn'
>;

/**
 * Hook to test Git installation connection
 * @returns Query result with connection test status
 */
export const useTestGitInstallationConnectionQuery = (
  installationId?: number,
  options?: OmittedQueryOptions,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.GIT_INSTALLATION_TEST_CONNECTION, installationId],
    queryFn: () => {
      if (!installationId) {
        throw new Error('Installation ID is required');
      }

      return RepositoryClient.testGitInstallationConnection(installationId);
    },
    enabled: !!installationId && (options?.enabled ?? true),
    ...options,
  });
